import React, { Component } from 'react';
import classes from './EmailForm.module.scss';

import { connect } from "react-redux";
import axios from 'axios';

import Button from '../../../components/Button/Button';
import Aux from '../../../hoc/Aux';

class EmailForm extends Component {

    Constants = require( '../../../data/' + this.props.mode + '-constants.js' );

    state = {
        show_form: true,
        show_form_message: false,
        form_message_class: '',
        form_message: '',
        form_emails: {
            quote_email_1: {
                email: '',
                valid: true,
            },
        },
        form_button_disabled: false,
    };

    resetEmailForm = () => {

        this.setState( {
            show_form: true,
            show_form_message: false,
            form_message_class: '',
            form_message: '',
            form_emails: {
                quote_email_1: {
                    email: '',
                    valid: true,
                }
            },
            form_button_disabled: false,
        } );

    };


    sendEmailQuote = ( event ) => {
        event.preventDefault();

        Object.keys( this.state.form_emails ).map( ( input_name, index ) => {
            let form_email = this.state.form_emails[ input_name ];

            if ( form_email.email === '' ) {
                return null;
            }

            let is_valid_email = this.isValidEmail( form_email.email );

            this.setState( {
                form_emails: {
                    ...this.state.form_emails,
                    [ input_name ]: {
                        ...this.state.form_emails[ input_name ],
                        valid: is_valid_email,
                    }
                }
            } );

            return null;
        } );

        let request_emails = [];

        Object.values( this.state.form_emails ).map( email_object => {

            if ( email_object.valid && email_object.email !== '' ) {
                request_emails.push( email_object.email );
            }

            return null;
        } );

        if ( !request_emails.length ) {
            // No emails were provided at all.
            this.setState( {
                show_form_message: true,
                form_message_class: 'Error',
                form_message: 'Oops! No valid email addresses were provided. Please enter at least one valid email address.',
            } );

            return null;
        }

        const request_data = {
            mode: this.props.mode,
            quote_hash: this.props.quoteHash,
            emails: request_emails,
        };

        axios.post( this.Constants.ENDPOINTS.email, request_data )
            .then( result => {

                switch ( result.status ) {
                    case 200:
                        this.setState( {
                            show_form: false,
                            show_form_message: true,
                            form_message_class: 'Success',
                            form_message: (
                                <div id="new-quote-emailed">
                                    <p>Awesome! We've emailed your quote to { request_emails.join( ', ' ) }</p>
                                    <Button buttonType="button" onButtonClick={ () => this.resetEmailForm() }
                                            addClass={ classes.TextButton }>Click here to email your quote to someone else</Button>
                                </div>
                            ),
                        } );
                        break;
                    case 404:
                        this.setState( {
                            show_form_message: true,
                            form_message_class: 'Error',
                            form_message: (
                                <Aux>
                                    Oops! Our system encountered a problem. You'll need to start over. Please give us a call at (888)
                                    778-4393 if you need help. <Button buttonType="button" onButtonClick={ () => this.sendEmailQuote() }>Try
                                    Again?</Button>
                                </Aux>
                            )
                        } );
                        break;
                    case 412:
                        this.setState( {
                            show_form_message: true,
                            form_message_class: 'Error',
                            form_message: (
                                <Aux>
                                    Oops! Our system failed to email your quote. Please double check your email address(es). Please give us
                                    a call at (888) 778-4393 if you need help. <Button buttonType="button"
                                                                                       onButtonClick={ () => this.sendEmailQuote() }>Try
                                    Again?</Button>
                                </Aux>
                            )
                        } );
                        break;
                    default:
                        break;
                }

            } );

    };

    isValidEmail = ( email ) => {
        const pattern = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;

        return pattern.test( email.trim() );
    };

    generateEmailFields = () => {

        return Object.keys( this.state.form_emails ).map( ( input_name, index ) => {
            return (
                <div key={ index } className={ classes.EmailFormField }>
                    <input type="email" name={ input_name } value={ this.state.form_emails[ input_name ].email } placeholder="Email address"
                           onChange={ this.handleEmailChange } onBlur={ this.handleEmailBlur }/>

                    { ( !this.state.form_emails[ input_name ].valid ) ? (
                        <span>Invalid</span>
                    ) : null }
                </div>
            );
        } );

    };

    handleEmailChange = ( event ) => {

        this.setState( {
            show_form_message: false,
            form_message_class: '',
            form_message: '',
            form_emails: {
                ...this.state.form_emails,
                [ event.target.name ]: {
                    email: event.target.value,
                    valid: true,
                }
            }
        } );

    };

    handleEmailBlur = ( event ) => {

        const isValidEmail = ( event.target.value !== '' ) ? this.isValidEmail( event.target.value ) : true;

        const allEmailsValid = this.allEmailsValid();

        this.setState( {
            form_emails: {
                ...this.state.form_emails,
                [ event.target.name ]: {
                    email: event.target.value,
                    valid: isValidEmail,
                }
            },
            form_button_disabled: ( !allEmailsValid ),
        } );

    };

    allEmailsValid = () => {

        let allEmailsValid = true;

        Object.keys( this.state.form_emails ).map( form_email_key => {

            if ( !this.isValidEmail( this.state.form_emails[ form_email_key ].email ) ) {
                allEmailsValid = false;
            }

            return null;
        } );

        return allEmailsValid;

    };

    addEmailField = () => {

        let newFieldIndex = ( Object.keys( this.state.form_emails ).length + 1 );

        this.setState( {
            form_emails: {
                ...this.state.form_emails,
                [ 'quote_email_' + newFieldIndex ]: {
                    email: '',
                    valid: true,
                },
            }
        } );

    };



    render() {

        if ( parseInt( this.props.quoteId ) === 0 ) {
            // Failed to create a quote. Show a friendly message instead of the Email Quote form.
            return (
                <div className={ classes.EmailQuoteForm }>
                    Oops! Our system failed to generate your quote. You'll need to start over. Please give us a call at (888) 778-4393 if
                    you need help.
                </div>
            );
        }

        const emailFormFields = this.generateEmailFields();

        return (
            <div className={ classes.EmailQuoteForm }>
                <h2 className={ classes.HeadingEmailQuote }>Book a Free Consultation</h2>
                <div className={ classes.MeetingScheduler }>
                    <iframe
                        title="Brightfire Sales Meeting"
                        src="https://meetings.brightfire.com/meetings/bob-whitis/sales?embed=true"
                        frameBorder="0"
                        style={{ width: '100%', height: '700px' }}
                    ></iframe>
                </div>

                <h2 className={ classes.HeadingEmailQuote }>Not quite ready? Save your quote for later.</h2>

                <form onSubmit={ this.sendEmailQuote }>
                    { this.state.show_form_message ? (
                        <div
                            className={ [ classes.FormMessage, classes[ this.state.form_message_class ] ].join( ' ' ) }>{ this.state.form_message }</div>
                    ) : null }

                    { this.state.show_form ? (
                        <Aux>
                            <div className={ classes.EmailFormFields }>
                                { emailFormFields }
                            </div>
                            <div className={ classes.AddEmailField }>
                                <Button buttonType="button"
                                        onButtonClick={ this.addEmailField }
                                        textLink={ true }>Add another email</Button>
                            </div>

                            <Button buttonType="submit" buttonDisabled={ ( this.state.form_button_disabled ) ? 'disabled' : null }>Email
                                My Quote</Button>
                        </Aux>
                    ) : null }
                </form>
            </div>

        );

    }

}

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( EmailForm );